import MyModifiedLettersTable from "../components/tables/MyModifiedLettersTable";

function MyModifiedLettersOverview() {
  return (
       <>
           <MyModifiedLettersTable/>
       </> 
      
  );
}

export default MyModifiedLettersOverview;

